// 役満選択モーダル/タグ/hidden inputs 管理
$(document).on('turbolinks:load', function () {
  // 役満チェッカー見出し
  var $yakumanChecker = $('#yakuman-checker');
  if ($yakumanChecker.length === 0) return;

  // モーダル
  var $modal = $('#yakuman-modal');
  var currentPlayerId = null;

  // ＋役満ボタン
  $(document).on('click', '.yakuman-select-btn', function () {
    currentPlayerId = $(this).data('player-id');

    // 既存選択をモーダルにプリセット
    var $btn = $('.yakuman-select-btn[data-player-id="' + currentPlayerId + '"]');
    var selectedKindsStr = ($btn.data('selectedKinds') || $btn.attr('data-selected-kinds') || '').toString();
    var selectedKinds = selectedKindsStr.length ? selectedKindsStr.split(',').filter(Boolean) : [];
    // 念のため重複排除
    selectedKinds = Array.from(new Set(selectedKinds));
    var localName = ($btn.data('localName') || $btn.attr('data-local-name') || '').toString();

    $modal.find('.js-yakuman-kind-checkbox').each(function(){
      $(this).prop('checked', selectedKinds.includes($(this).val()));
    });
    $modal.find('.yakuman-local-input').val(localName);

    try {
      // Bootstrap 5 APIで表示
      var modalEl = document.getElementById('yakuman-modal');
      var instance = bootstrap.Modal.getOrCreateInstance(modalEl);
      instance.show();
    } catch (e) {
      // フォールバック（jQueryプラグインがある場合）
      if ($modal && typeof $modal.modal === 'function') {
        $modal.modal('show');
      }
    }
  });

  // 適用ボタン
  $(document).on('click', '#yakuman-modal-apply', function(){
    if (currentPlayerId === null) return;

    var proData = $('#yakuman-checker').data('pro');
    var isPro = (proData === true || proData === 'true');

    if (!isPro) {
      var msgProOnly = $('#yakuman-checker').data('msg-pro-only') || '';
      alert(msgProOnly);
      return;
    }

    var kinds = $modal.find('.js-yakuman-kind-checkbox:checked').map(function(){ return $(this).val(); }).get();
    var localName = ($modal.find('.yakuman-local-input').val() || '').trim();

    // hidden inputs 更新
    var $hidden = $('.yakuman-hidden-inputs[data-player-id="' + currentPlayerId + '"]');
    $hidden.empty();

    kinds.forEach(function(k){
      var $input = $('<input>', { type: 'hidden', name: 'match[yakumans][' + currentPlayerId + '][kinds][]', value: k });
      $hidden.append($input);
    });
    if (localName.length > 0) {
      var $local = $('<input>', { type: 'hidden', name: 'match[yakumans][' + currentPlayerId + '][local_name]', value: localName });
      $hidden.append($local);
    }

    // タグ描画
    var $tags = $('.yakuman-tags[data-player-id="' + currentPlayerId + '"]');
    $tags.empty();
    kinds.forEach(function(k){
      var $cb = $modal.find('.js-yakuman-kind-checkbox[value="' + k + '"]');
      var label = ($cb.data('label') || $cb.closest('label').text() || '').toString().trim();
      var $tag = $('<span>', { class: 'badge-orange' }).text(label);
      $tags.append($tag);
    });
    if (localName.length > 0) {
      var localLabel = localName;
      var $localTag = $('<span>', { class: 'badge-orange' }).text(localLabel);
      $tags.append($localTag);
    }

    // ボタン側のデータ属性も最新に更新（次回プリセット用）
    var $btn = $('.yakuman-select-btn[data-player-id="' + currentPlayerId + '"]');
    var kindsStr = kinds.join(',');
    $btn.data('selectedKinds', kindsStr);
    $btn.attr('data-selected-kinds', kindsStr);
    $btn.data('localName', localName);
    $btn.attr('data-local-name', localName);

    try {
      var modalEl = document.getElementById('yakuman-modal');
      var instance = bootstrap.Modal.getOrCreateInstance(modalEl);
      instance.hide();
    } catch (e) {
      if ($modal && typeof $modal.modal === 'function') {
        $modal.modal('hide');
      }
    }
  });
});


